import { parseISO, getDay, isValid, Locale } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import { ja } from "date-fns/locale/ja";
import { zhCN } from "date-fns/locale/zh-CN";
import { zhTW } from "date-fns/locale/zh-TW";
import { ko } from "date-fns/locale/ko";

export function parseDate(date: string | Date): Date {
  let newDate: string | Date = date;
  if (typeof newDate === "string") {
    newDate = newDate.replace(/\//g, "-");
    return parseISO(newDate);
  }
  return newDate;
}

export function getLocale(userLocale: string): Locale {
  switch (userLocale) {
    case "en":
      return enUS;
    case "ja":
      return ja;
    case "zh_cn":
      return zhCN;
    case "zh_tw":
      return zhTW;
    case "ko":
      return ko;
  }
}

export function isWeekend(date: string | Date): boolean {
  let dateObject: Date;
  if (typeof date === "string") {
    dateObject = parseDate(date);
  } else {
    dateObject = date;
  }
  if (isValid(dateObject)) {
    const day = getDay(dateObject);
    const targetDays = [0, 6];
    if (targetDays.includes(day)) {
      return true;
    }
  }
  return false;
}
